var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget',{attrs:{"title":'App - '+_vm.app.app_name,"icon":"fa-th-large","max-height":_vm.maxHeight}},[_c('iframe',{style:({height:_vm.iframeHeight}),attrs:{"id":"appIframe","src":_vm.iframeSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }